import { showFromFade, loadLibrary } from "../../js/Util";
import { LIB_URL } from '../../js/App';

$(".js-advantages-tab").click(function () {
    let $el = $(this);
    if (!$el.hasClass("_active")) {
        $(".js-advantages-tabs").find("._active").removeClass("_active");
        $el.addClass("_active");
        $(".js-advantages-tab--content").hide();
        $el.find(".js-advantages-tab--content").show(100);
        $(".js-advantages-imgs").find("img").hide();
        $("#" + $el.data("switch")).fadeIn(300);
    } else {
        return false;
    }
});

$('.js-available-titles-slider-mobile').each((i, sliderDom) => {
    loadLibrary(LIB_URL.SWIPER, () => {
        const availableTilesSlider = new Swiper(sliderDom, {
            slidesPerView: "auto",
            spaceBetween: 16,
            on: {
                resize: function enableOnlyMobile(swiper) {
                    if (App.W.width() > 1100) {
                        swiper.disable();
                    } else {
                        swiper.enable();
                    }
                },
            },
        });

        if (App.W.width() > 1100) {
            availableTilesSlider.disable();
        } else {
            availableTilesSlider.enable();
        }
    });
});


if ($(".service-top-item").length) {
    $(".service-top-item").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=15%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
if ($(".service-tile").length) {
    $(".service-tile").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
if ($(".available-tile:not(.available-tile-adv)").length) {
    $(".available-tile:not(.available-tile-adv)").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
if ($(".advantages-wrap").length) {
    $(".advantages-wrap").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
